// extracted by mini-css-extract-plugin
export var container = "_4i-0";
export var infoButton = "_4i-1";
export var label = "_4i-3";
export var labelExpanded = "_4i-4";
export var price = "_4i-5";
export var priceExpanded = "_4i-6";
export var title = "_4i-2";